import { useTranslation } from 'react-i18next';

import { PageToolbar } from '@packages/components/page/page-toolbar';

import { useFlowDataTypeParam } from '../../hooks/use-flow-data-type-param/use-flow-data-type-param';

export const RequestHelp = () => {
  const { t } = useTranslation('flow');
  const flowDataType = useFlowDataTypeParam();

  const flowDataTypeName = t(`tabs.${flowDataType}`);

  return (
    <PageToolbar.RequestHelp
      state={{
        initialInfo: {
          subject: t('contactConciergeSubjectLine', {
            flowDataType: flowDataTypeName,
          }),
        },
      }}
    />
  );
};
